<template>
  <div>
    <c-model
      ref="roomModelContent"
      title="考场信息"
      width="50%"
      @confirm="saveInfo()"
      :tips="[{
        type:'备注',
        value:'准考证分配时会按照考场编号升序优先分配'
      }]"
    >
      <el-button
        type="primary"
        size="small"
        @click="addRoom"
        v-if="!disabled"
      >增加考场</el-button>

      <el-form
        ref="roomForm"
        :model="dataList"
        :disabled="disabled"
      >
        <el-table
          :data="dataList.rows"
          class="table-center linkModel"
        >

          <el-table-column
            prop="name"
            label="考场名称"
          >
            <template slot-scope="{row,$index}">
              <el-form-item
                label="考场名称"
                :prop="'rows.'+$index+'.name'"
                hiddenLabel
                hiddenErrorText
                required
              >
                <el-input v-model="row.name"></el-input>
              </el-form-item>

            </template>

          </el-table-column>

          <el-table-column
            prop="postName"
            label="考场编号"
          >
            <template slot-scope="{row,$index}">
              <el-form-item
                label="考场编号"
                :prop="'rows.'+$index+'.code'"
                hiddenLabel
                hiddenErrorText
                required
              >
                <el-input v-model="row.code"></el-input>
              </el-form-item>
            </template>

          </el-table-column>

          <el-table-column
            prop="postNumber"
            label="考场岗位"
          >
            <template slot-scope="{row,$index}">
              <div
                class="roomPointInfo"
                @click="editPost($index,row.examPlacePostList)"
              >
                <div v-if="row.examPlacePostList.length===0">
                  <p>点击分配</p>
                </div>
                <div v-else>
                  <p v-for="post in row.examPlacePostList">{{post.examPostName}}({{post.number}}人)</p>
                </div>

              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80px"
             v-if="!disabled"
          >
            <template slot-scope="{row,$index}">
              <div class="actions">
                <a @click="deleteRoom($index)">删除</a>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </el-form>

    </c-model>
    <c-model
      ref="postModel"
      title="考场岗位信息"
      @confirm="savePost"
    >
      <el-button
        type="primary"
        size="small"
        @click="addPost"
        v-if="!disabled"
      >增加考场岗位</el-button>

      <el-form
        ref="postForm"
        :model="postList"
        :disabled="disabled"
      >
        <el-table
          :data="postList.rows"
          class="table-center linkModel"
        >
          <el-table-column
            prop="postName"
            label="考场岗位"
          >
            <template slot-scope="{row,$index}">
              <el-form-item
                label="考场岗位"
                :prop="'rows.'+$index+'.examPostId'"
                hiddenLabel
                hiddenErrorText
                required
              >
                <el-select v-model="row.examPostId">
                  <el-option
                    v-for="item in postOptions"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>

          </el-table-column>

          <el-table-column
            prop="postName"
            label="岗位人数"
          >
            <template slot-scope="{row,$index}">
              <el-form-item
                label="岗位人数"
                :prop="'rows.'+$index+'.number'"
                hiddenLabel
                hiddenErrorText
                required
              >
                <el-input v-model="row.number"></el-input>
              </el-form-item>
            </template>

          </el-table-column>

          <el-table-column
            label="操作"
            width="80px"
             v-if="!disabled"
          >
            <template slot-scope="{row,$index}">
              <div class="actions">
                <a @click="deletePost($index)">删除</a>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </el-form>

    </c-model>
  </div>
</template>

<script>
import TableMixin from "@/mixins/TableMixin";
import { recruitRes } from "@/api";
export default {
  mixins: [TableMixin],
  props: {
    data: {
      default: () => {
        return [];
      }
    },
    examId: String,
    disabled: false
  },
  data() {
    return {
      dataList: {
        rows: []
      },
      postList: {
        rows: []
      },
      postOptions: [],
      activeIndex: ""
    };
  },
  watch: {
    data(newData) {
      var rows = JSON.parse(JSON.stringify(newData));
      this.dataList = { rows };
    },
    examId(newData) {
      this.getPostOptions(newData);
    }
  },
  created() {},
  methods: {
    //获取招聘信息的岗位
    getPostOptions(id) {
      recruitRes.getPostList({ examId: id }).then(res => {
        this.postOptions = res || [];
      });
    },
    open() {
      this.openModel("roomModelContent");
    },
    close() {
      this.closeModel("roomModelContent");
    },
    cancel() {
      this.close();
    },
    saveInfo() {
      this.$refs.roomForm.validate(valid => {
        if (valid) {
          this.$emit("saveRoom", this.dataList.rows);
        }
      });
    },
    addRoom() {
      this.dataList.rows.push({ name: "", code: "", examPlacePostList: [] });
    },
    deleteRoom(index) {
      this.dataList.rows.splice(index, 1);
    },
    //编辑考场岗位
    editPost($index, postList) {
      this.activeIndex = $index;
      this.postList.rows = Object.assign([], postList);
      this.openModel("postModel");
    },
    //添加考场岗位
    addPost() {
      this.postList.rows.push({});
    },
    //删除考场岗位
    removePost() {},
    //保存考场岗位
    savePost() {
      var that = this;
      this.$refs.postForm.validate(valid => {
        if (valid) {
          //判断岗位是否重复,
          var { rows } = that.postList;
          var flag = false;
          for (var i = 0, len = rows.length; i < len; i++) {
            var item1 = rows[i];
            for (var j = 1; j < len; j++) {
              var item2 = rows[j];
              if (i !== j) {
                if (item1.examPostId === item2.examPostId) {
                  flag = true;
                  break;
                }
              }
            }

            for (var k = 0, klen = this.postOptions.length; k < klen; k++) {
              var item3 = this.postOptions[k];
              if (item3.id === item1.examPostId) {
                this.$set(item1, "examPostName", item3.name);
                break;
              }
            }
            if (flag) {
              break;
            }
          }

          if (flag) {
            this.$message.error("考场岗位不能重复!");
            return;
          }
          that.dataList.rows[that.activeIndex].examPlacePostList = rows;

          //岗位id获取岗位名称
          that.closeModel("postModel");
        }
      });
    },
    deletePost(index) {
      var { rows } = this.postList;
      rows.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.linkModel {
  .el-date-editor.el-input,
  .el-select {
    width: 100%;
  }
}
.roomPointInfo {
  cursor: pointer;
  p {
    margin: 0;
    padding: 0;
    text-decoration: underline;
  }
}
</style>

